import { idOrLegacyId } from '../../../entities/properties/selectors';
import { IState } from '../../../store/reducer';

type SelectorKey = keyof IState['views']['property']['edit']['images'];

const photoViewSelector = (key: SelectorKey) => (propertyId: string | number, state: IState) => {
	const lookupId = idOrLegacyId(propertyId);
	return state.views.property.edit.images[key]?.[lookupId];
};

export const photosUploading = photoViewSelector('uploading');
export const photosDeleting = photoViewSelector('deleting');
export const photosErrors = photoViewSelector('errors');
export const photosSuccesses = photoViewSelector('successes');

export const photosLoading = (propertyId: string | number, state: IState) => {
	const lookupId = idOrLegacyId(propertyId);
	return state.views.property.edit.images.loading[lookupId];
};
